import { createAsyncThunk } from "@reduxjs/toolkit";
import applicationApi from "api/applicationApi";
import { formatQueryParams } from "helpers/format";

export const getApplications = createAsyncThunk(
  "Applications",
  async (params: any = {}) => {
    try {
      const response = await applicationApi.getApplications(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);
